<template>
  <Layout :title="title">
    <Title
      v-if="!executed"
      :icon="assetType.meta.icon"
      :heading="assetType.meta.heading"
      :sub-heading="assetType.meta.subHeading"
    />

    <SubNavigation
      v-if="!executed"
      :active="active"
      :assetType="assetType"
      :asset="asset"
      :tabs="tabs"
    />

    <slot />
  </Layout>
</template>

<script>
import helpers from '@/Mixins/helpers';
import contractState from '@/Mixins/contractState';
import Layout from '@/Shared/Layout';
import Title from '@/Shared/Title';
import SubNavigation from './Shared/SubNavigation';

export default {
  mixins: [helpers, contractState],

  components: {
    Layout,
    Title,
    SubNavigation,
  },

  props: {
    assetType: Object,
    active: String,
    title: String,
    asset: Object,
  },

  mounted() {
    if (this.asset) {

      this.fetchAssetState(this.asset.id);
    }
  },

  data() {
    return {
      sent: false,
    };
  },

  computed: {
    executed() {
      if (!this.asset) return false;
      return this.asset.state === 'executed';
    },

    tabs() {
      return [
        {
          name: 'basic',
          visible: true,
          label: 'Basic Information',
          route: 'basic',
          enabled: !this.withCounterparty,
        },
        {
          name: 'configure',
          visible: true,
          label: `Edit ${this.assetType.name} Template`,
          route: 'configure',
          enabled: true,
        },
        {
          name: 'approval',
          visible: this.sendForApprovalVisible,
          label: 'Send for Approval',
          route: 'approval',
          enabled: true,
        },
        {
          name: 'send',
          visible: this.sendToCounterPartyVisible,
          label: 'Send to Counterparty',
          route: 'send',
          enabled: true,
        },
      ];
    },

    sendForApprovalVisible() {
      if (!this.userHasPermissionTo('send_for_approval')) return false;

      if (!this.asset) return false

      if (this.asset && this.userHasType('clausify')) {
        const originator = this.$page.props.auth.user.organisation.id === this.asset.organisation_id;

        // If you're Originator and it's with Counterparty - you shouldn't see this
        if (originator && this.state.withCounterparty) {
          return false;
        }

        // If you're Counterparty and it's with Originator - you shouldn't see this
        if (!originator && !this.state.withCounterparty) {
          return false;
        }
      }

      return ['editing', 'pending', 'signed'].includes(this.state.state);
    },

    sendToCounterPartyVisible() {
      if (!this.userHasPermissionTo('send_to_counter_party')) return false;

      if (!this.asset) return false

      if (this.asset && this.userHasType('clausify')) {
        const originator = this.$page.props.auth.user.organisation.id === this.asset.organisation_id;

        // If you're Originator and it's with Counterparty - you should see this
        if (originator && this.state.withCounterparty) {
          return true;
        }

        // If you're Counterparty and it's with Originator - you should see this
        if (!originator && !this.state.withCounterparty) {
          return true;
        }
      }

      return ['approved', 'reviewing'].includes(this.state.state);
    },
  },
};
</script>
